import dayjs from "dayjs";
import actions from "./actions";

const initState = {
  invoices: [],
  invoiceTabIndex: 0,
  incomingInvoiceForm: {
    date_range: [dayjs().add(-1, "M"), dayjs()],
    invoice_status: "All",
  },
  outgoingInvoiceForm: {
    date_range: [dayjs().add(-1, "M"), dayjs()],
    invoice_status: "All",
  },
  invoiceForm: {
    date_range: [dayjs().add(-1, "d"), dayjs()],
    invoice_status: "All",
  },
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.SET_INVOICE_FORM: {
      return {
        ...state,
        invoiceForm: action.payload,
      };
    }
    case actions.SET_INCOMING_INVOICE_FORM: {
      return {
        ...state,
        incomingInvoiceForm: action.payload,
      };
    }
    case actions.SET_OUTGOING_INVOICE_FORM: {
      return {
        ...state,
        outgoingInvoiceForm: action.payload,
      };
    }
    case actions.SET_INVOICE_TAB_INDEX: {
      return {
        ...state,
        invoiceTabIndex: action.payload,
      };
    }
    case actions.SET_ALL_INVOICES: {
      return {
        ...state,
        invoices: action.payload,
      };
    }
    default:
      return state;
  }
}
